import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDefectNietInzetbaarXs = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={16}
    height={16}
    viewBox='0 0 16 16'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.71002 7L5.60002 11H8.00002V12H5.34002L4.79002 14H7.02002V15H2.02002C1.74002 15 1.52002 14.78 1.52002 14.5C1.52002 14.22 1.74002 14 2.02002 14H3.75002L7.20002 1.51C7.27002 1.2 7.56002 1 7.87002 1H8.15002C8.46002 1 8.75002 1.2 8.82002 1.51L10.48 7.5H9.44002L9.30002 7H6.71002ZM8.00502 2.33804L6.99002 6H9.02002L8.00502 2.33804Z'
    />
    <path d='M14.86 8.85L12.21 11.5H12.19L14.84 14.15C15.04 14.35 15.04 14.66 14.84 14.86C14.75 14.96 14.61 15.01 14.49 15.01C14.37 15.01 14.24 14.96 14.14 14.86L11.49 12.21L8.84002 14.86C8.75002 14.96 8.61002 15.01 8.49002 15.01C8.37002 15.01 8.24002 14.96 8.14002 14.86C7.94002 14.66 7.94002 14.35 8.14002 14.15L10.79 11.5L8.14002 8.85C7.94002 8.65 7.94002 8.34 8.14002 8.14C8.34002 7.94 8.65002 7.94 8.85002 8.14L11.5 10.79L14.15 8.14C14.35 7.94 14.66 7.94 14.86 8.14C15.06 8.34 15.06 8.65 14.86 8.85Z' />
  </svg>
);
export default SvgDefectNietInzetbaarXs;
